import { Button } from '@mui/material';
import { FC } from 'react';

export const PrivacyNotice: FC = () => (
    <Button
        href='https://www.cen-grp.com/privacy-policy'
        target='_blank'
        rel='noreferrer'
    >
        Privacy Notice
    </Button>
);
